import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgIdleModule } from "@ng-idle/core";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { ProgressBarModule } from "primeng/progressbar";
import { SharedModule } from "../shared/shared.module";
import { HomePageUrlService } from "./api/url-guards/home-page-url.service";
import { AccessDeniedComponent } from "./error/access-denied/access-denied.component";
import { PageNotFoundComponent } from "./error/page-not-found/page-not-found.component";
import { AccountMenuComponent } from "./header/account-menu/account-menu.component";
import { HeaderComponent } from "./header/header.component";
import { SearchService } from "./header/search.service";
import { SearchComponent } from "./header/search/search.component";
import { IdleComponent } from "./idle/idle.component";
import { MenuButtonComponent } from "./menu/menu-button/menu-button.component";
import { PlatformComponent } from "./platform.component";
import { PlatformService } from "./platform.service";

@NgModule({
    imports: [
        SharedModule,
        BrowserAnimationsModule,
        ProgressBarModule,
        OverlayPanelModule,
        NgIdleModule.forRoot(),
    ],
    declarations: [
        PlatformComponent,
        HeaderComponent,
        MenuButtonComponent,
        PageNotFoundComponent,
        AccessDeniedComponent,
        AccountMenuComponent,
        SearchComponent,
        IdleComponent,
    ],
    providers: [
        PlatformService,
        HomePageUrlService,
        SearchService,

    ],
    exports: [
        PlatformComponent,
    ],
})
export class PlatformModule { }
